import { useState, useEffect, lazy, useRef, useMemo, memo } from "react";
import axios from 'axios';

import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from "react-helmet";
import { Carousel } from "react-bootstrap";
import CountUp from "react-countup";
const ClientList = lazy(() => import("../../components/ClientList"))

import Loading from "../../components/Loading";
import CareerBanner2 from "../../components/CareerBanner2";
import style from "./_style.module.scss"
import Hero from "../../components/Hero";
import IndustryInsights from "./HomePage/IndustryInsightsComponent"
import Card from "../../components/Card";


import PublicationsComponent from "./HomePage/PublicationsComponent";
import IndustryInsightsComponent from "./HomePage/IndustryInsightsComponent";
import OfficeListComponent from "./HomePage/OfficeListComponent";
import RetailListComponent from "./HomePage/RetailListComponent";
import CommListComponent from "./HomePage/CommListComponent";
import IndustrialListComponent from "./HomePage/IndustialListComponent";
import LotListComponent from "./HomePage/LotListComponent";
import DistrictsComponent from "./HomePage/DistrictsComponent";
import ObserverComponent from "../../components/LazyLoad/ObserverComponent";
import noimage from "../../assets/mocks/noimage.png"

export default memo(function () {

    const url = process.env.REACT_APP_API_URL;
    const listingURL = process.env.REACT_APP_LISTING_API_URL;

    const [reject, setReject] = useState<boolean>(false)
    const inquireRef: any = useRef<any>(null)
    const [loaded, setLoaded] = useState<boolean>(false)
    const [isMobile, setIsMobile] = useState(window.document.body.offsetWidth < 576)

    const meta = {
        title: 'The Leading Commercial Real Estate Consultancy Firm in the Philippines | PRIME Philippines',
        description: 'Learn about the PRIME Advantage and how we can provide customized solutions to help you succeed in the real estate industry. Discover our expertise, experience, and dedication to delivering exceptional service.',
        canonical: 'https://www.primephilippines.com',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Real Estate Service Provider in PH, Real Estate Service Provider in the Philippines, Real Estate Service Firm in PH, Real Estate Service Firm in the Philippines, Jet Yu, PRIME Philippines, PRIME'
            },
            itemProp: {
                name: 'The Leading Commercial Real Estate Consultancy Firm in the Philippines | PRIME Philippines',
                description: 'The Leading Commercial Real Estate Consultancy Firm in the Philippines.',
                image: 'https://www.primephilippines.com/media/logos/prime-logo.webp',
            },
            property: {
                'og:title': 'The Leading Commercial Real Estate Consultancy Firm in the Philippines | PRIME Philippines',
                'og:description': 'The Leading Commercial Real Estate Consultancy Firm in the Philippines.',
                'og:image': 'https://www.primephilippines.com/media/logos/prime-logo.webp',
                'og:url': 'https://www.primephilippines.com',
                'og:type': 'website',
                'twitter:title': 'The Leading Commercial Real Estate Consultancy Firm in the Philippines | PRIME Philippines',
                'twitter:description': 'The Leading Commercial Real Estate Consultancy Firm in the Philippines.',
                'twitter:image': 'https://www.primephilippines.com/media/logos/prime-logo.webp',
                'twitter:url': 'https://www.primephilippines.com',
            }
        },
    };
    const {
        OfficeList,
        CommList,
        IndusList,
        RetailList,
        LotList,
        MetaTags,
        Insights,
        Publications,
        Districts
    } = useSelector((state: any) => state.home)
    const dispatch = useDispatch()
    const asyncLoadMetaTags = async () => {
        if (MetaTags) {
            // setMetaTags(MetaTags)
            return
        }
        const response = await axios.get('homeMeta.json')
        const data = response.data
        dispatch({ type: 'home/setMetaTags', payload: data })
        // setMetaTags(response.data)
    }
    const asyncLoadPublications = async () => {
        const response = await axios.get(url + "publication", {
            params: {
                '_embed': 'wp:featuredmedia',
                per_page: '3',
            },
        })
        const data = response.data
        console.log(data)
        dispatch({ type: 'home/setPublications', payload: data })
        // const { default: Element } = await import("./HomePage/PublicationsComponent").then((res) => res)
        // setPublication(() => <Element Publications={data} />)
    }
    const asyncLoadInsights = async () => {
        const response = await axios.get(url + "insights", {
            params: {
                '_embed': 'author',
                'per_page': '3',
            },
        })
        const data = response.data
        dispatch({ type: 'home/setInsights', payload: data })
    }
    const asyncLoadOfficeList = async () => {
        const response = await axios.get(listingURL + "", {
            params: {
                'type': '5',
                'limit': '3',
                'is_key_project': '1'
            }
        })
        const data = response.data.data
        dispatch({ type: 'home/setOfficeList', payload: data })
    }
    const asyncLoadRetailList = async () => {
        const response = await axios.get(listingURL + "", {
            params: {
                'type': '4',
                'limit': '3',
                'is_key_project': '1'
            }
        })
        const data = response.data.data
        dispatch({ type: 'home/setRetailList', payload: data })
    }
    const asyncLoadCommList = async () => {
        const response = await axios.get(listingURL + "", {
            params: {
                'type': '3',
                'limit': '3',
                'is_key_project': '1'
            }
        })
        const data = response.data.data
        dispatch({ type: 'home/setCommList', payload: data })
    }
    const asyncLoadIndusList = async () => {
        const response = await axios.get(listingURL + "", {
            params: {
                'type': '2',
                'limit': '3',
                'is_key_project': '1'
            }
        })
        const data = response.data.data
        dispatch({ type: 'home/setIndusList', payload: data })
    }
    const asyncLoadLotList = async () => {
        const response = await axios.get(listingURL + "", {
            params: {
                'type': '1',
                'limit': '3',
                'is_key_project': '1'
            }
        })
        const data = response.data.data
        dispatch({ type: 'home/setLotList', payload: data })
    }
    const asyncLoadDistricts = async () => {
        const response = await axios.get(url + "business_district", {
            params: {
                '_embed': 'wp:featuredmedia',
                'order': 'asc',
            },
        })
        const data = response.data
        dispatch({ type: 'home/setDistricts', payload: data })
    }
    useEffect(() => {
        (
            async () => {
                if (!reject) {
                    await asyncLoadMetaTags()
                    // await asyncLoadPublications()
                    // await asyncLoadInsights()
                    // await asyncLoadOfficeList()
                    // await asyncLoadRetailList()
                    // await asyncLoadCommList()
                    // await asyncLoadIndusList()
                    // await asyncLoadLotList()
                    // await asyncLoadDistricts()
                    setLoaded(true)
                }
            }
        )()
        return () => setReject(true)
    }, [])
    useEffect(() => {
        const handleResize = () => {
            const isMobileSize = window.document.body.offsetWidth < 576
            setIsMobile(isMobileSize);
            console.log("video")
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [window])
    const scrollTo = () => {
        window.scrollTo({
            behavior: "smooth",
            top: inquireRef.current.offsetTop - 200
        })
    }
    const headerDesktop = "https://s3.ap-southeast-1.amazonaws.com/assets.primephilippines.com/wp-content/uploads/2023/08/home-page-header1.webm"
    const headerMobile = "https://s3.ap-southeast-1.amazonaws.com/assets.primephilippines.com/wp-content/uploads/2023/08/home-page-header2.webm"

    const { PublicationsMemo, MobilePublicationsMemo } = useMemo(() => {
        if (!Publications) {
            return {
                PublicationsMemo: <div>Loading...</div>,
                MobilePublicationsMemo: <div>Loading...</div>
            }
        }
        return {
            PublicationsMemo: <PublicationsComponent Publications={Publications} />,
            MobilePublicationsMemo: <>
                <Carousel>
                    {
                        Publications?.map((publication: any, key: number) => (
                            <Carousel.Item key={key}>
                                <Card
                                    key={"publ" + publication.slug}
                                    height="38rem !important"
                                    class="col-12 col-md-3 col-sm-12 "
                                    imageClass="pt-5 mh-25rem object-contain"
                                    bodyClass="fs-6 text-truncate-two"
                                    titleTextColor="text-primary"
                                    subtitleTextColor="text-grey-700"
                                    image={publication?._embedded ? publication?._embedded['wp:featuredmedia'][0]?.source_url : noimage}
                                    title={publication.title.rendered}
                                    date={new Date(publication.date).toDateString().split(' ').slice(1).join(' ')}
                                    body={publication.content.rendered}
                                    link={"/publications/" + publication.slug}
                                />
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
                <div className=" bg-primary d-flex align-items-center justify-content-center">
                    <div className="card bg-transparent p-5">
                        <Link to={"/publications"}><p className="fw-bolder text-secondary fs-3">CHECK THE REST OF OUR PUBLICATIONS <i className="fas fa-chevron-right text-secondary"></i></p></Link>
                    </div>
                </div>
            </>
        }
    }, [Publications])
    const { IndustryInsightsMemo, MobileIndustryInsightsMemo } = useMemo(() => {
        if (!Insights) {
            return {
                IndustryInsightsMemo: <div>Loading...</div>,
                MobileIndustryInsightsMemo: <div>Loading...</div>
            }
        }
        return {
            IndustryInsightsMemo: <IndustryInsightsComponent Insights={Insights} />,
            MobileIndustryInsightsMemo: <Carousel>
                <Carousel.Item>
                    {Insights?.length > 0 && <Card
                        class="col-12 col-lg-4"
                        bgColor="bg-primary"
                        titleTextColor="text-secondary fs-3"
                        subtitleTextColor="text-white"
                        bodyClass="text-white text-truncate-two"
                        title={Insights[0].title.rendered}
                        date={new Date(Insights[0].date).toDateString().split(' ').slice(1).join(' ')}
                        author={" • " + Insights[0]._embedded.author[0].name}
                        body={Insights[0].content.rendered.substring(0, 122)}
                        link={"/insights/article/" + Insights[0].slug}
                    />}
                </Carousel.Item>
                {
                    Insights?.slice(1, 3)?.map((insight: any, index: number) => (
                        <Carousel.Item key={index}>
                            <Card
                                key={"insight" + index}
                                class="col-12 col-lg-4 col-sm-12"
                                bgColor="bg-white"
                                titleTextColor="text-primary fs-3"
                                subtitleTextColor="text-grey-700"
                                bodyClass="text-truncate-two"
                                title={insight.title.rendered}
                                date={new Date(insight.date).toDateString().split(' ').slice(1).join(' ')}
                                author={" • " + insight._embedded.author[0].name}
                                body={insight.content.rendered.substring(0, 122)}
                                link={"/insights/article/" + insight.slug}
                            />
                        </Carousel.Item>
                    ))
                }
            </Carousel>
        }
    }, [Insights])
    const { OfficeListMemo, MobileOfficeListMemo } = useMemo(() => {
        if (!OfficeList) {
            return {
                OfficeListMemo: <div>Loading...</div>,
                MobileOfficeListMemo: <div>Loading...</div>
            }
        }
        return {
            OfficeListMemo: <OfficeListComponent OfficeList={OfficeList} />,
            MobileOfficeListMemo: <>
                <div className="mt-5">
                    <h1 className="display-6 text-uppercase text-primary fw-bolder">Our Key Projects</h1>
                    <img
                        loading="lazy"
                        src="/media/divisors/key-projects-bar.webp"
                        className="mt-n5 img-fluid"
                        alt="Image"
                    />
                    <h2 className="fs-1 fw-bolder text-uppercase">Key Office Building Projects</h2>
                    <p className="col-md-5 fs-4">
                        We offer a wide range of properties that suit every need from government and private companies, big or small, local or international.
                    </p>
                </div>
                <Carousel>
                    {
                        OfficeList?.map((content: any, key: number) => (
                            <Carousel.Item key={key}>
                                <div className="shadow-card card position-relative">
                                    <span className="position-absolute text-primary fw-bold bg-secondary p-2">For Lease</span>
                                    <img loading="lazy" src={content.images[0]} className="card-img-top img-hover-zoom img-fluid object-cover " style={{ height: "300px", width: "100%" }} alt={content.property_name} />
                                    <div className="card-img-overlay bg-dark bg-gradient opacity-25">
                                    </div>
                                    <div className="card-img-overlay d-flex flex-column-reverse">
                                        <h5 className="text-white m-2">{content.address}</h5>
                                        <Link to={`/listings/${content.slug}`} className="stretched-link" aria-label={content.property_name}>
                                            <h5 className="card-title text-white fw-bolder m-2 fs-2">{content.property_name}</h5>
                                        </Link>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
                <div className=" bg-primary d-flex align-items-center justify-content-center">
                    <div className="card bg-transparent p-5">
                        <Link to={"/find-a-property/search?type=Office+Spaces"}><p className="fw-bolder text-secondary fs-2">VIEW OTHER OFFICE SPACES <i className="fas fa-chevron-right text-secondary"></i></p></Link>
                    </div>
                </div>
            </>
        }
    }, [OfficeList])
    const { OfficeRetailMemo, MobileOfficeRetailMemo } = useMemo(() => {
        if (!RetailList) {
            return {
                OfficeRetailMemo: <div>Loading...</div>,
                MobileOfficeRetailMemo: <div>Loading...</div>
            }
        }
        return {
            OfficeRetailMemo: <RetailListComponent RetailList={RetailList} />,
            MobileOfficeRetailMemo: <>
                <div className="mt-5">
                    <h2 className="fs-1 fw-bolder text-uppercase">Key Retail Building Projects</h2>
                    <p className="col-md-5 fs-4">
                        From commercial spaces to commercial lots, ranging from big to small, there's a PRIME property that can accomodate new and existing businesses.
                    </p>
                </div>
                <Carousel>
                    {
                        RetailList?.map((content: any, key: number) => (
                            <Carousel.Item key={key}>
                                <div className="shadow-card card position-relative">
                                    <span className="position-absolute text-primary fw-bold bg-secondary p-2">For Lease</span>
                                    <img loading="lazy" src={content.images[0]} className="card-img-top img-hover-zoom img-fluid object-cover " style={{ height: "300px", width: "100%" }} alt={content.property_name} />
                                    <div className="card-img-overlay bg-dark bg-gradient opacity-25">
                                    </div>
                                    <div className="card-img-overlay d-flex flex-column-reverse">
                                        <h5 className="text-white m-2">{content.address}</h5>
                                        <Link to={`/listings/${content.slug}`} className="stretched-link" aria-label={content.property_name}>
                                            <h5 className="card-title text-white fw-bolder m-2 fs-2">{content.property_name}</h5>
                                        </Link>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
                <div className=" bg-primary d-flex align-items-center justify-content-center">
                    <div className="card bg-transparent p-5">
                        <Link to={"/find-a-property/search?type=Retail+Spaces"}><p className="fw-bolder text-secondary fs-2">VIEW OTHER RETAIL SPACES <i className="fas fa-chevron-right text-secondary"></i></p></Link>
                    </div>
                </div>
            </>
        }
    }, [RetailList])
    const { CommercialMemo, MobileCommercialMemo } = useMemo(() => {
        if (!CommList) {
            return {
                CommercialMemo: <div>Loading...</div>,
                MobileCommercialMemo: <div>Loading...</div>
            }
        }
        return {
            CommercialMemo: <CommListComponent CommList={CommList} />,
            MobileCommercialMemo: <>
                <div className="mt-5">
                    <h2 className="fs-1 fw-bolder text-uppercase">Key Commercial Lots</h2>
                    <p className="col-md-5 fs-4">
                        From commercial spaces to commercial lots, ranging from big to small, there's a PRIME property that can accommodate new and existing businesses.
                    </p>
                </div>
                <Carousel>
                    {
                        CommList?.map((content: any, key: number) => (
                            <Carousel.Item key={key}>
                                <div className="shadow-card card position-relative">
                                    <span className="position-absolute text-primary fw-bold bg-secondary p-2">For Lease</span>
                                    <img loading="lazy" src={content.images[0]} className="card-img-top img-hover-zoom img-fluid object-cover " style={{ height: "300px", width: "100%" }} alt={content.property_name} />
                                    <div className="card-img-overlay bg-dark bg-gradient opacity-25">
                                    </div>
                                    <div className="card-img-overlay d-flex flex-column-reverse">
                                        <h5 className="text-white m-2">{content.address}</h5>
                                        <Link to={`/listings/${content.slug}`} className="stretched-link" aria-label={content.property_name}>
                                            <h5 className="card-title text-white fw-bolder m-2 fs-2">{content.property_name}</h5>
                                        </Link>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
                <div className=" bg-primary d-flex align-items-center justify-content-center">
                    <div className="card bg-transparent p-5">
                        <Link to={"/find-a-property/search?type=Commercial+Lots"}><p className="fw-bolder text-secondary fs-3">VIEW OTHER COMMERCIAL LOTS <i className="fas fa-chevron-right text-secondary"></i></p></Link>
                    </div>
                </div>
            </>
        }
    }, [CommList])
    const { IndustrialMemo, MobileIndustrialMemo } = useMemo(() => {
        if (!IndusList) {
            return {
                IndustrialMemo: <div>Loading...</div>,
                MobileIndustrialMemo: <div>Loading...</div>
            }
        }
        return {
            IndustrialMemo: <IndustrialListComponent IndusList={IndusList} />,
            MobileIndustrialMemo: <>
                <div className="mt-5">
                    <h2 className="fs-1 fw-bolder text-uppercase">Key Industrial Warehouses</h2>
                    <p className="col-md-5 fs-4">
                        Get your industrial real estate requirement satisfied in any major industrial hub in the Philippines.
                    </p>
                </div>
                <Carousel>
                    {
                        IndusList?.map((content: any, key: number) => (
                            <Carousel.Item key={key}>
                                <div className="shadow-card card position-relative">
                                    <span className="position-absolute text-primary fw-bold bg-secondary p-2">For Lease</span>
                                    <img loading="lazy" src={content.images[0]} className="card-img-top img-hover-zoom img-fluid object-cover " style={{ height: "300px", width: "100%" }} alt={content.property_name} />
                                    <div className="card-img-overlay bg-dark bg-gradient opacity-25">
                                    </div>
                                    <div className="card-img-overlay d-flex flex-column-reverse">
                                        <h5 className="text-white m-2">{content.address}</h5>
                                        <Link to={`/listings/${content.slug}`} className="stretched-link" aria-label={content.property_name}>
                                            <h5 className="card-title text-white fw-bolder m-2 fs-2">{content.property_name}</h5>
                                        </Link>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
                <div className=" bg-primary d-flex align-items-center justify-content-center">
                    <div className="card bg-transparent p-5">
                        <Link to={"/find-a-property/search?type=Industrial+Warehouse"}><p className="fw-bolder text-secondary fs-3">VIEW OTHER INDUSTRIAL WAREHOUSES <i className="fas fa-chevron-right text-secondary"></i></p></Link>
                    </div>
                </div>
            </>
        }
    }, [IndusList])
    const { LotListMemo, MobileLotListMemo } = useMemo(() => {
        if (!LotList) {
            return {
                LotListMemo: <div>Loading...</div>,
                MobileLotListMemo: <div>Loading...</div>
            }
        }
        return {
            LotListMemo: <LotListComponent LotList={LotList} />,
            MobileLotListMemo: <>
                <div className="mt-5">
                    <h2 className="fs-1 fw-bolder text-uppercase">Key Industrial Lots</h2>
                    <p className="col-md-5 fs-4">
                        Get your industrial real estate requirement satisfied in any major industrial hub in the Philippines.
                    </p>
                </div>
                <Carousel>
                    {
                        IndusList?.map((content: any, key: number) => (
                            <Carousel.Item key={key}>
                                <div className="shadow-card card position-relative">
                                    <span className="position-absolute text-primary fw-bold bg-secondary p-2">For Lease</span>
                                    <img loading="lazy" src={content.images[0]} className="card-img-top img-hover-zoom img-fluid object-cover " style={{ height: "300px", width: "100%" }} alt={content.property_name} />
                                    <div className="card-img-overlay bg-dark bg-gradient opacity-25">
                                    </div>
                                    <div className="card-img-overlay d-flex flex-column-reverse">
                                        <h5 className="text-white m-2">{content.address}</h5>
                                        <Link to={`/listings/${content.slug}`} className="stretched-link" aria-label={content.property_name}>
                                            <h5 className="card-title text-white fw-bolder m-2 fs-2">{content.property_name}</h5>
                                        </Link>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
                <div className=" bg-primary d-flex align-items-center justify-content-center">
                    <div className="card bg-transparent p-5">
                        <Link to={"/find-a-property/search?type=Industrial+Lots"}><p className="fw-bolder text-secondary fs-3">VIEW OTHER INDUSTRIAL LOTS <i className="fas fa-chevron-right text-secondary"></i></p></Link>
                    </div>
                </div>
            </>
        }
    }, [LotList])
    const { DistrictsMemo, MobileDistrictsMemo } = useMemo(() => {
        if (!Districts) {
            return {
                DistrictsMemo: <div>Loading...</div>,
                MobileDistrictsMemo: <div>Loading...</div>
            }
        }
        return {
            DistrictsMemo: <DistrictsComponent Districts={Districts} />,
            MobileDistrictsMemo: <>
                <div className="d-flex flex-column justify-content-center h-50 m-auto">
                    <h1 className="display-6 text-uppercase text-primary fw-bolder">Business Districts in the Philippines</h1>
                    <img loading="lazy"
                        src="/media/divisors/640_business-districts-bar.webp"
                        className="img-fluid" alt="Image" />

                    <p className="fs-2 mt-5">Our dedicated teams across multiple offices in the Philippines can guide your entry into any business district in the country.</p>
                </div>
                <Carousel>
                    {
                        Districts?.map((content: any, index: number) => (
                            <Carousel.Item key={index}>
                                <div className={"shadow-card card h-50"}>
                                    <img loading="lazy" src={content?._embedded ? content?._embedded['wp:featuredmedia'][0]?.source_url : noimage} className={"object-cover w-100 img-hover-zoom overflow-hidden"} style={{ height: "300px" }} alt={content.acf.blurb} />
                                    <div className="card-img-overlay bg-dark bg-gradient opacity-25">
                                    </div>
                                    <div className="card-img-overlay d-flex flex-column text-center justify-content-center">
                                        <h5 className="card-title text-secondary fw-bold fs-2">{content.title.rendered}</h5>
                                        <Link to={"/business-districts/" + content.slug} className="stretched-link" aria-label={content.acf.blurb}>
                                            <h6 className="text-white">{content.acf.blurb}</h6>
                                        </Link>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
            </>
        }
    }, [Districts])

    const componentMounted = () => {
        return
    }

    return (
        <>
            <Helmet>
                <title>{meta?.title}</title>
                <meta name="description" content={meta?.description} />
                <link rel="canonical" href={meta?.canonical} />
                <meta charSet={meta?.meta?.charset} />
                <meta name="keywords" content={meta?.meta?.name.keywords} />
                <meta name={meta?.meta?.itemProp.name} content={meta?.meta?.itemProp.name} />
                <meta name={meta?.meta?.itemProp.description} content={meta?.meta?.itemProp.description} />
                <meta name={meta?.meta?.itemProp.image} content={meta?.meta?.itemProp.image} />

                <meta property="og:title" content={meta?.meta?.property['og:title']} />
                <meta property="og:description" content={meta?.meta?.property['og:description']} />
                <meta property="og:image" content={meta?.meta?.property['og:image']} />
                <meta property="og:url" content={meta?.meta?.property['og:url']} />
                <meta property="og:type" content={meta?.meta?.property['og:type']} />

                <meta name="twitter:title" content={meta?.meta?.property['twitter:title']} />
                <meta name="twitter:description" content={meta?.meta?.property['twitter:description']} />
                <meta name="twitter:image" content={meta?.meta?.property['twitter:image']} />
                <meta name="twitter:url" content={meta?.meta?.property['twitter:url']} />
            </Helmet>
            <div className="container-fluid">
                <ObserverComponent loaded={true} load={async () => await componentMounted()}>
                    <Hero opacity="opacity-67"
                        bgColor="bg-dark"
                        width="100%"
                        height="100%"
                        poster="https://primephilippines.com/images/home/640_homepage-mobile-cover.webp"
                        video={[isMobile ? headerMobile : headerDesktop]}
                    />
                </ObserverComponent>
                <div className="d-flex flex-center pb-5 mx-md-20 mt-10">
                    <div className="row text-center w-100 d-flex flex-row justify-content-evenly">
                        <div className="col-12 col-lg-3">
                            <p className="display-4 fw-bold text-primary">
                                USD{" "}<CountUp end={500} duration={5} useEasing />M+
                            </p>
                            <p className="h5 mt-n5 text-gray-800">worth of deals transacted</p>
                        </div>
                        <div className="col-4 col-lg-3">
                            <p className=" display-4 fw-bold text-primary"><CountUp end={7000} duration={5} useEasing />+</p>
                            <p className="h5 mt-n5 text-gray-800">clients served</p>
                        </div>
                        <div className="col-4 col-lg-3">
                            <p className="display-4 fw-bold text-primary"><CountUp end={300} duration={5} useEasing />+</p>
                            <p className="h5 mt-n5 text-gray-800">real estate projects</p>
                        </div>
                        <div className="col-4 col-lg-3">
                            <p className="display-4 fw-bold text-primary"><CountUp end={150} duration={5} useEasing />+</p>
                            <p className="h5 mt-n5 text-gray-800">research studies done</p>
                        </div>
                    </div>
                </div>
                <hr className="bg-primary border-4 border-top border-primary" />
                <div className="container">
                    <div className="row text-center">
                        <h1 className="col display-5 fw-normal">
                            An <span className="text-primary"> award-winning </span> &amp;
                            recognized leader in the Philippine commercial and industrial real
                            estate service industry.
                        </h1>
                    </div>
                    <div className="row text-center">
                        <div className="col fs-1 mx-xl-20 px-xl-20">
                            <span className="text-primary fw-bolder">
                                Entrust your real estate needs
                            </span>{" "}
                            to a company well-equipped to deal with today's modern real estate
                            business, with offices in <b>Manila</b>, <b>Davao</b>, and <b>Cebu</b>
                            .
                        </div>
                    </div>
                </div>
                <div className="">
                    <ObserverComponent loaded={Publications?.length > 0} load={async () => await asyncLoadPublications()}>
                        <div className="d-flex justify-content-center my-4">
                            <div className={`btn btn-primary fs-3 ${!loaded ? "opacity-50" : "opacity-100"}`} onClick={() => loaded && scrollTo()}>Inquire Now</div>
                        </div>
                        <div className="mt-5 mb-5">
                            <h1 className="display-6 text-uppercase text-primary fw-bolder">
                                Research &amp; Advisory
                            </h1>
                            <img
                                loading="lazy"
                                src="/media/divisors/research-advisory-bar.webp"
                                className="mt-n5 img-fluid"
                                alt="Divisor"
                            />
                            <h3 className="fs-1 fw-bolder">FEATURED PUBLICATIONS</h3>
                        </div>
                        {/* Publications */}
                        <div className={style.web_view}>{PublicationsMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobilePublicationsMemo}</div>}
                    </ObserverComponent>

                    <ObserverComponent loaded={Insights?.length > 0} load={async () => await asyncLoadInsights()}>
                        {/* Industry Insights */}
                        {isMobile && <h3 className="fs-1 fw-bolder mt-4">INDUSTRY INSIGHTS</h3>}
                        <div id="industry_insights" className={style.web_view}>{IndustryInsightsMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobileIndustryInsightsMemo}</div>}
                    </ObserverComponent>

                    <ObserverComponent loaded={OfficeList?.length > 0} load={async () => await asyncLoadOfficeList()}>
                        {/* Office Lists */}
                        <div id="office_projects" className={style.web_view}>{OfficeListMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobileOfficeListMemo}</div>}
                    </ObserverComponent>

                    <ObserverComponent loaded={CommList?.length > 0} load={async () => await asyncLoadCommList()}>
                        {/* Commercial Lots */}
                        <div className={style.web_view}>{CommercialMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobileCommercialMemo}</div>}
                    </ObserverComponent>

                    <ObserverComponent loaded={RetailList?.length > 0} load={async () => await asyncLoadRetailList()}>
                        {/* Office Retail */}
                        <div className={style.web_view}>{OfficeRetailMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobileOfficeRetailMemo}</div>}
                    </ObserverComponent>

                    <ObserverComponent loaded={IndusList?.length > 0} load={async () => await asyncLoadIndusList()}>
                        {/* Industrial Warehouses */}
                        <div className={style.web_view}>{IndustrialMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobileIndustrialMemo}</div>}
                    </ObserverComponent>

                    <ObserverComponent loaded={LotList?.length > 0} load={async () => await asyncLoadLotList()}>
                        {/* Industrial Lots */}
                        <div className={style.web_view}>{LotListMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobileLotListMemo}</div>}
                    </ObserverComponent>

                    <ObserverComponent loaded={true} load={async () => await componentMounted()}>
                        <div className={style.careers_mobile}>
                            <div className="card overflow-hidden w-100 d-flex align-items-center justify-content-evenly" style={{ height: 150 }}>
                                <img
                                    loading="eager"
                                    src="https://wp.primephilippines.com/wp-content/uploads/2023/03/contact-header-image.jpg"
                                    className="w-100 h-75 object-cover"
                                    style={{
                                        backgroundPositionY: -200,
                                        filter: "brightness(0.5)"
                                    }}
                                    alt="Banner"
                                />
                                <div className={`${style.text_overflow}`}>
                                    <h1 className="display-6 fw-bolder text-white" >
                                        Let our dedicated teams take care of your property.
                                    </h1>
                                </div>
                                <div className={style.button_wrapper}>
                                    <Link to="/contact-us" className={`${style.text} text-secondary btn btn-primary fw-bold`}>LIST YOUR PROPERTY</Link>
                                </div>
                            </div>
                        </div>
                    </ObserverComponent>
                    <ObserverComponent loaded={Districts?.length > 0} load={async () => await asyncLoadDistricts()}>
                        {/* Business Districts */}
                        <div className={style.web_view}>{DistrictsMemo}</div>
                        {isMobile && <div className={style.carousel}>{MobileDistrictsMemo}</div>}
                    </ObserverComponent>
                </div>
                <ObserverComponent loaded={true} load={async () => await componentMounted()}>
                    <div className="careers">
                        <ClientList />
                    </div>
                    <CareerBanner2 ref={inquireRef} />
                    <div className={style.careers_mobile}>
                        <div className="card overflow-hidden w-100 d-flex align-items-center justify-content-evenly" style={{ height: 150 }}>
                            <img
                                loading="lazy"
                                src={"/media/careers/640_bg-productivity.webp"}
                                className="w-100 h-75 object-cover"
                                style={{
                                    backgroundPositionY: -200,
                                    filter: "brightness(0.5)",
                                }}
                                alt="Banner"
                            />
                            <div className={`${style.text_overflow2}`}>
                                <h1 className="display-6 fw-bolder text-white" >
                                    Be part of a company that invests in YOU
                                </h1>
                            </div>
                            <div className={style.button_wrapper}>
                                <Link to="/careers" className={`${style.text} text-secondary btn btn-primary fw-bold`}>EXPLORE OPPORTUNITIES</Link>
                            </div>
                        </div>
                    </div>
                </ObserverComponent>
            </div>
        </>
    )
})